import { render, staticRenderFns } from "./SelectOidcGroupModal.vue?vue&type=template&id=97016e74&"
import script from "./SelectOidcGroupModal.vue?vue&type=script&lang=js&"
export * from "./SelectOidcGroupModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports